module.exports = __webpack_public_path__ + "static/media/LA.be4b04b7.png";